module.exports = __webpack_public_path__ + "static/media/footer-messages-active.60d447f4.png";